<template>
  <b-tr>
    <!-- Grazed/Fed -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(grazing.grazing_grazed_fed,isFieldInCache(field,year,rowIndex,'grazing_grazed_fed'))"
    >
      <PracticeChoiceDropdown
        clearable
        dense
        hide-details="true"
        :items="grazedFedChoices"
        item-text="display_name"
        item-value="value"
        v-model="grazedFed"
        choiceName="pasture_grazing_grazed_fed"
        :append-icon="
          grazing.grazing_grazed_fed !== null
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('grazedFed', grazedFed)"
      />
    </b-td>
    <!-- dates -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(grazing.grazing_date_start,isFieldInCache(field,year,rowIndex,'grazing_date_start'))"
    >
      <v-menu
        v-model="showStartDate"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <div class="d-flex">
            <div class="date-holder">
              <v-text-field
                v-model="startDate"
                dense
                readonly
                hide-details="true"
                v-bind="attrs"
                v-on="on"
                :append-icon="
                  grazing.grazing_date_start !== null
                    ? 'mdi-check-circle-outline'
                    : ''
                "
                @click:append="handleClickSubmit('startDate', startDate)"
              ></v-text-field>
            </div>
          </div>
        </template>
        <v-date-picker
          v-model="startDate"
          :min="year + '-01-01'"
          :max="year + '-12-31'"
          @input="showDate = false"
          scrollable
        ></v-date-picker>
      </v-menu>
    </b-td>
    <!-- grazing end date -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(grazing.grazing_date_end,isFieldInCache(field,year,rowIndex,'grazing_date_end'))"
    >
      <v-menu
        v-model="showEndDate"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <div class="d-flex">
            <div class="date-holder">
              <v-text-field
                v-model="endDate"
                dense
                readonly
                hide-details="true"
                v-bind="attrs"
                v-on="on"
                :append-icon="
                  grazing.grazing_date_end !== null
                    ? 'mdi-check-circle-outline'
                    : ''
                "
                @click:append="handleClickSubmit('endDate', endDate)"
              ></v-text-field>
            </div>
          </div>
        </template>
        <v-date-picker
          v-model="endDate"
          :min="year + '-01-01'"
          :max="year + '-12-31'"
          @input="showDate = false"
          scrollable
        ></v-date-picker>
      </v-menu>
    </b-td>
    <!-- rest period -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(grazing.grazing_rest_period,isFieldInCache(field,year,rowIndex,'grazing_rest_period'))"
    >
      <v-text-field
        clearable
        dense
        v-model="restPeriod"
        hide-details="true"
        suffix="days"
        :append-icon="
          grazing.grazing_rest_period !== null
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('restPeriod', restPeriod)"
      >
      </v-text-field>
    </b-td>
    <!-- rotational grazed -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(grazing.grazing_rotational_grazed,isFieldInCache(field,year,rowIndex,'grazing_rotational_grazed'))"
    >
      <v-select
        clearable
        dense
        hide-details="true"
        :items="yesNoOptions"
        item-text="display_name"
        item-value="value"
        v-model="rotationalGrazed"
        :append-icon="
          grazing.grazing_rotational_grazed !== null
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('rotationalGrazed', rotationalGrazed)"
      />
    </b-td>
    <!-- Feed Ration Type -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(grazing.grazing_feed_ration_type,isFieldInCache(field,year,rowIndex,'grazing_feed_ration_type'))"
    >
      <PracticeChoiceDropdown
        clearable
        dense
        hide-details="true"
        :items="feedRationTypeChoices"
        item-text="display_name"
        item-value="value"
        v-model="feedRationType"
        choiceName="pasture_grazing_feed_ration_type"
        :append-icon="
          grazing.grazing_feed_ration_type !== null
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('feedRationType', feedRationType)"
      />
    </b-td>
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(grazing.grazing_feed_ration_percent_crude_protein,isFieldInCache(field,year,rowIndex,'grazing_feed_ration_percent_crude_protein'))"
    >
      <v-text-field
        clearable
        dense
        v-model="feedRationPercentCrudeProtein"
        hide-details="true"
        :append-icon="
          grazing.grazing_feed_ration_percent_crude_protein !== null
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('feedRationPercentCrudeProtein', feedRationPercentCrudeProtein)"
      >
      </v-text-field>
    </b-td>
    <!-- Percent Edible Oil -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(grazing.grazing_percent_edible_oil,isFieldInCache(field,year,rowIndex,'grazing_percent_edible_oil'))"
    >
      <PracticeChoiceDropdown
        clearable
        dense
        hide-details="true"
        :items="percentEdibleOilChoices"
        item-text="display_name"
        item-value="value"
        v-model="percentEdibleOil"
        choiceName="pasture_grazing_percent_edible_oil"
        :append-icon="
          grazing.grazing_percent_edible_oil !== null
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('percentEdibleOil', percentEdibleOil)"
      />
    </b-td>
    <b-td class="cell-table white">
      <v-btn icon x-small color="black" @click="handleAdd">
        <v-icon>mdi-plus-circle-outline</v-icon>
      </v-btn>
      <v-btn icon x-small color="black" @click="handleDelete" v-if="dataLength > 1">
        <v-icon>mdi-close-circle-outline</v-icon>
      </v-btn>.
    </b-td>
  </b-tr>
</template>
<script>
import { mapMutations, mapGetters,mapActions } from "vuex"
import { CROP_DROPDOWN_OPTIONS, YES_NO_OPTIONS } from "@/constants"
import { Defaults } from "@/store/modules"
import { getClassForCell } from "../utils"
import PracticeChoiceDropdown from "@/components/dropdowns/PracticeChoiceDropdown"


export default {
  name: "RanchGrazingRow",
  props: {
    additionView: { type: Boolean, default: false },
    cropId: { type: Number },
    field: { type: String },
    grazing: { type: Object },
    rowIndex: { type: Number },
    dataLength:{type:Number},
    year: { type: String },
  },
  components: {
    PracticeChoiceDropdown,
  },
  data() {
    return {
      cropChoices: CROP_DROPDOWN_OPTIONS,
      yesNoOptions: YES_NO_OPTIONS,
      showStartDate: false,
      showEndDate: false,
      getClassForCell
    }
  },
  computed: {
    ...mapGetters({
      practiceChoices: Defaults.Getters.getPracticeChoices,
      isFieldInCache: Defaults.Getters.isFieldInCache,
    }),
    feedRationTypeChoices() {
      return this.practiceChoices["pasture_grazing_feed_ration_type"]
    },
    percentEdibleOilChoices() {
      return this.practiceChoices["pasture_grazing_percent_edible_oil"]
    },
    grazedFedChoices() {
      return this.practiceChoices["pasture_grazing_grazed_fed"]
    },
    grazedFed: {
      get() {
        return this.grazing.grazing_grazed_fed
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "operation",
          dataSetting: "grazing_grazed_fed",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetUpdate(updatePayload)
      },
    },
    feedRationType: {
      get() {
        return this.grazing.grazing_feed_ration_type
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "operation",
          dataSetting: "grazing_feed_ration_type",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetUpdate(updatePayload)
      },
    },
    percentEdibleOil: {
      get() {
        return this.grazing.grazing_percent_edible_oil
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "operation",
          dataSetting: "grazing_percent_edible_oil",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetUpdate(updatePayload)
      },
    },
    crop: {
      get() {
        return this.grazing.crop_id
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "grazings",
          dataSetting: "crop_id",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetUpdate(updatePayload)
      },
    },
    startDate: {
      get() {
        const dateReturn = this.grazing.grazing_date_start
          ? this.grazing.grazing_date_start
          : `${this.year}-01-01`
        return dateReturn
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "operation",
          dataSetting: "grazing_date_start",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetUpdate(updatePayload)
      },
    },
    endDate: {
      get() {
        const dateReturn = this.grazing.grazing_date_end
          ? this.grazing.grazing_date_end
          : `${this.year}-01-01`
        return dateReturn
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "operation",
          dataSetting: "grazing_date_end",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetUpdate(updatePayload)
      },
    },
    ranchGrazingDates: {
      get() {
        return {
          start: this.grazing.grazing_date_start,
          end: this.grazing.grazing_date_end,
        }
      },
      set(val) {
        // this.grazing.date_start.value = val.start
        const startPayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "operation",
          dataSetting: "grazing_date_start",
          value: val.start,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetUpdate(startPayload)

        const endPayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "operation",
          dataSetting: "grazing_date_end",
          value: val.end,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetUpdate(endPayload)
        // this.grazing.date_end.value = val.end

        // this.grazing.date_start.source = "User Input"
        // this.grazing.date_end.source = "User Input"
      },
    },
    restPeriod: {
      get() {
        return this.grazing.grazing_rest_period
      },
      set(val) {
        if (val === "") {
          val = null
        }
        let validVal = this.handleValidateValue(val, "number")
        if (validVal) {
          const updatePayload = {
            fieldId: this.field,
            year: this.year,
            crop: this.cropId,
            dataCategory: "operation",
            dataSetting: "grazing_rest_period",
            value: val,
            rowIndex: this.rowIndex,
          }
          this.spreadsheetUpdate(updatePayload)
        }
      },
    },
    feedRationPercentCrudeProtein: {
      get() {
        return this.grazing.grazing_feed_ration_percent_crude_protein
      },
      set(val) {
        if (val === "") {
          val = null
        }
        let validVal = this.handleValidateValue(val, "number")
        if (validVal) {
          const updatePayload = {
            fieldId: this.field,
            year: this.year,
            crop: this.cropId,
            dataCategory: "operation",
            dataSetting: "grazing_feed_ration_percent_crude_protein",
            value: val,
            rowIndex: this.rowIndex,
          }
          this.spreadsheetUpdate(updatePayload)
        }
      },
    },
    rotationalGrazed: {
      get() {
        if (typeof this.grazing.grazing_rotational_grazed == "string") {
          return this.yesNoMapper[this.grazing.grazing_rotational_grazed]
        }
        return this.grazing.grazing_rotational_grazed
      },
      set(val) {
        const updatePayload = {
          fieldId: this.field,
          year: this.year,
          crop: this.cropId,
          dataCategory: "operation",
          dataSetting: "grazing_rotational_grazed",
          value: val,
          rowIndex: this.rowIndex,
        }
        this.spreadsheetUpdate(updatePayload)
      },
    },
  },
  methods: {
    ...mapMutations({
      addFieldSettingRow: Defaults.Mutations.addFieldSettingRow,
      deleteNewFieldSetting: Defaults.Mutations.deleteNewFieldSetting,
      updateNewFieldSetting: Defaults.Mutations.updateNewFieldSetting,
      spreadsheetMutate: Defaults.Mutations.spreadsheetMutate,
    }),
    ...mapActions({
      spreadsheetUpdate: Defaults.Actions.spreadsheetUpdate,
    }),
    handleClickSubmit(setting, val) {
      this[setting] = val
    },
    handleCopy() {
      this.$emit("handle-copy", this.grazing)
    },
    handleAdd() {
      const payloadObj = {
        crop_id:this.cropId,
        grazing_date_start: null,
        grazing_date_end: null,
        grazing_rest_period: null,
        grazing_rotational_grazed: null,
        grazing_feed_ration_type: null,
        grazing_feed_ration_percent_crude_protein: null,
        grazing_percent_edible_oil: null,
        year:this.year,
        defaults_template:this.grazing.defaults_template,
      }
      this.addFieldSettingRow({
        fieldId: this.field,
        cropId: this.cropId,
        dataCategory: "operation",
        dataObj: payloadObj,
        year: this.year,
      })
    },
    handleDelete() {
      this.deleteNewFieldSetting({
        fieldId: this.field,
        cropId: this.cropId,
        dataCategory: "operation",
        recordId: this.grazing.id,
        rowIndex: this.rowIndex,
        year: this.year,
      })
    },
    handleValidateValue(val, type, length = 24, range = null) {
      function isNumeric(val) {
        return !isNaN(val) && !isNaN(parseFloat(val));
      }

      if (val === null) {
        return true
      }

      if (val.length > length) {
        this.$emit(
          "bad-input",
          "Inputted value length was too long (24 characters allowed)."
        )
        return false
      }

      if (type == "number") {
        if (isNumeric(val)) {
          if (range !== null) {
            if (val >= range[0] && val <= range[1]) {
              return true
            } else {
              this.$emit(
                "bad-input",
                `Look out! Only a value between ${range[0]} and ${range[1]} can be entered here.`
              )
              return false
            }
          }
          return true
        } else {
          this.$emit(
            "bad-input",
            "Look out! A numerical value is expected here."
          )
          return false
        }
      } else if (type == "string") {
        return true
      }
    },
    filter(event, fieldInput) {
      event = event ? event : window.event
      let expect = event.target.value.toString() + event.key.toString()

      let range = null
      let inputType = "number"

      if (fieldInput === "stocking-rate") range = [0, 10000]
      else if (fieldInput === "utilization-pct") range = [0, 100]

      let validVal = this.handleValidateValue(expect, inputType, 24, range)
      if (!validVal) event.preventDefault()
    },
  },
}
</script>
<style scoped>
.arva-alert {
  background-color: #f7c0be;
}

.arva-generated {
  background-color: #fedb80;
}

.pre-gen {
  background-color: #fedb80;
}

.bg-white {
  color: white;
}

.cell-table {
  /* padding: 0; */
  padding: 2px 6px;
}

.cell-text {
  font-weight: 600;
  color: white;
}

.machine {
  background-color: #dbe6d6;
}
.complete {
  background-color: #c7e3c1;
}

.copy-icon {
  cursor: pointer;
  color: #0f9aee;
}

.input-check {
  cursor: pointer;
}

.select-check {
  margin-top: 14px;
  cursor: pointer;
}

.submit-icon {
  color: #c7e3c1;
}

.medium-column {
  width: 140px;
}

.large-column {
  width: 240px;
}

.marge-column {
  width: 180px;
}

.delete {
  color: #cc0101;
  cursor: pointer;
}

.copy-col {
  min-width: 44px;
}

.del-col {
  min-width: 40px;
}

.v-input {
  font-size: 18px;
}

.v-menu__content,
::v-deep(.v-menu__content) {
  max-height: 400px !important;
}
</style>
